module.exports = __webpack_public_path__ + "static/media/comment5_2.5e371b11.png";